module.exports = __webpack_public_path__ + "img/a7e7880bef7a4e67e4ecb227be4d7940.36c04aa1.jpg";